import script from "./VacancyHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./VacancyHeader.vue?vue&type=script&setup=true&lang=js"

import "./VacancyHeader.vue?vue&type=style&index=0&id=43fe80d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43fe80d8"]])

export default __exports__